import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { useEffect, useState, useContext, useCallback } from "react";
import Btn from "../../../../components/buttons/Btn";
import TabsErp from "../../../../components/tabs/TabsErp";
import { notify } from "../../../../utils/notify";
// import MaskService from "../../../../../utils/mask/maskService";
import BodySearchMovimentations from "./BodySearchMovimentations";
import BodySearchPaymentsReceipts from "./BodySearchPaymentsReceipts";
import BodySuggestions from "./BodySuggestions";
import useConciliacaoBancariaController from "../controllers/ConciliacaoBancariaController";
import { ConciliacaoBancariaContext } from "../contexts/ConciliacaoBancariaContext";
import { Add } from "@material-ui/icons";
import ModalNewMovimentation from "./ModalNewMovimentation";
import ModalNewPaymentsReceipts from "./ModalNewPaymentsReceipts";
import BtnMenu from "./BtnMenu";

const ModalSearch = ({
  open,
  setModalOpen,
  suggestions = [],
  pending = [],
  transactionType = "",
  callHandleActions = () => {},
  transactionAmount,
  transactionDate,
  transactionMemo,
}) => {
  const { getReceiptsbills, getMovimentations, getPaybills } =
    useConciliacaoBancariaController();

  const {
    searchPayments,
    searchReceipts,
    setSearchPayments,
    setSearchReceipts,
    searchMovimentations,
    setSearchMovimentations,
    itensTotalMovimentations,
    setItensTotalMovimentations,
    itensTotalPayments,
    setItensTotalPayments,
    itensTotalReceipts,
    setItensTotalReceipts,
  } = useContext(ConciliacaoBancariaContext);

  const [tabIndex, setTabIndex] = useState(0);
  const [selectedItems, setSelectedItems] = useState(pending || []);

  const [textFilterMovimentation, setTextFilterMovimentation] = useState("");

  const [textFilterPayments, setTextFilterPayments] = useState("");

  const [textFilterReceipts, setTextFilterReceipts] = useState("");

  const [openModalNewMovimentation, setOpenModalNewMovimentation] =
    useState(false);
  const [addPayments, setAddPayments] = useState(false);
  const [openModalNewPaymentsReceipts, setOpenModalNewPaymentsReceipts] =
    useState(false);

  const summedValue = selectedItems.reduce((acc, current) => {
    return (
      acc +
      parseFloat(current.valor || current.value || current.valordocto || 0.0)
    );
  }, 0);

  const summedFees = selectedItems.reduce((acc, current) => {
    return acc + parseFloat(current.fees || 0.0);
  }, 0);

  const summedFines = selectedItems.reduce((acc, current) => {
    return acc + parseFloat(current.fine || 0.0);
  }, 0);

  const summedAbatement = selectedItems.reduce((acc, current) => {
    return acc + parseFloat(current.abatement || 0.0);
  }, 0);

  const conditionToShow = !!suggestions.length;

  const handleOpenModalNewMovimentation = () => {
    setOpenModalNewMovimentation(true);
  };

  const handleOpenModalNewPaymentsReceipts = (isPayments = false) => {
    setAddPayments(isPayments);
    setOpenModalNewPaymentsReceipts(true);
  };

  const handleNewMovimentation = (newRow) => {
    setTextFilterMovimentation(newRow.historico || "");
    getMovimentations({
      type: whereTransactionType,
      newPage: 1,
      search: false,
      filter: newRow.historico,
    });
    setTabIndex(conditionToShow ? 2 : 1);
  };

  const handleNewPaymentsReceipts = (newRow) => {
    if (addPayments) {
      setTextFilterPayments(newRow.numerodocto || "");
      getPaybills(1, false, newRow.numerodocto);
    } else {
      setTextFilterReceipts(newRow.numerodocto || "");
      getReceiptsbills(1, false, newRow.numerodocto);
    }
    setTabIndex(conditionToShow ? 1 : 0);
  };

  const erpActions = [
    {
      label: "Movimentação Bancária",
      onClick: handleOpenModalNewMovimentation,
    },
    {
      label:
        transactionType === "CREDIT" ? "Contas a Receber" : "Contas a Pagar",
      onClick:
        transactionType === "CREDIT"
          ? () => handleOpenModalNewPaymentsReceipts()
          : () => handleOpenModalNewPaymentsReceipts(true),
    },
  ];

  const haderLabelComplement =
    transactionType === "CREDIT" ? "Receber / Pendentes" : "Pagar / Pendentes";

  const whereTransactionType = transactionType === "CREDIT" ? "C" : "D";

  const tabHeaders = [
    ...(conditionToShow
      ? [
          {
            label: "Sugestões",
          },
        ]
      : []),
    {
      label: `Contas a ${haderLabelComplement}`,
    },
    {
      label: "Mov. Bancária / Liquidações",
    },
  ];

  const tabChildren = [
    ...(conditionToShow
      ? [
          <BodySuggestions
            suggestions={suggestions}
            items={selectedItems}
            setItems={setSelectedItems}
            key="tab-sugestoes"
          />,
        ]
      : []),
    ...(whereTransactionType === "D"
      ? [
          <BodySearchPaymentsReceipts
            suggestions={searchPayments}
            items={selectedItems}
            setItems={setSelectedItems}
            key="tab-sugestoes-pagar"
            type={whereTransactionType}
            totalItens={itensTotalPayments}
            filter={textFilterPayments}
            setFilter={setTextFilterPayments}
          />,
        ]
      : [
          <BodySearchPaymentsReceipts
            suggestions={searchReceipts}
            items={selectedItems}
            setItems={setSelectedItems}
            key="tab-sugestoes-receber"
            type={whereTransactionType}
            totalItens={itensTotalReceipts}
            filter={textFilterReceipts}
            setFilter={setTextFilterReceipts}
          />,
        ]),
    <BodySearchMovimentations
      suggestions={searchMovimentations}
      items={selectedItems}
      setItems={setSelectedItems}
      key="tab-sugestoes-movimentacoes"
      type={whereTransactionType}
      totalItens={itensTotalMovimentations}
      filter={textFilterMovimentation}
      setFilter={setTextFilterMovimentation}
    />,
  ];

  const handleClose = () => {
    setModalOpen(false);
    setSelectedItems([]);

    setSearchPayments([]);
    setTextFilterPayments("");
    setItensTotalPayments(0);

    setSearchReceipts([]);
    setTextFilterReceipts("");
    setItensTotalReceipts(0);

    setSearchMovimentations([]);
    setTextFilterMovimentation("");
    setItensTotalMovimentations(0);
  };

  const handleAdd = () => {
    const selected = [...selectedItems];
    if (!selected.length) return notify("Nenhuma movimentação selecionada.");

    callHandleActions(selected);
    handleClose();
  };

  const handleGetData = useCallback(async () => {
    if (whereTransactionType === "D") {
      await getPaybills();
    } else {
      await getReceiptsbills();
    }
    await getMovimentations({
      type: whereTransactionType,
      whereNull: ["conciliacao_bancaria_id"],
    });
  }, [getMovimentations, getPaybills, getReceiptsbills, whereTransactionType]);

  useEffect(() => {
    if (!transactionType.length) return;
    handleGetData();
  }, [handleGetData, transactionType]);

  return (
    <>
      {openModalNewMovimentation && (
        <div>
          <ModalNewMovimentation
            open={openModalNewMovimentation}
            setModalOpen={setOpenModalNewMovimentation}
            tipo={transactionType}
            value={
              transactionAmount -
              (summedValue + summedFees + summedFines - summedAbatement)
            }
            transactionDate={transactionDate}
            transactionMemo={transactionMemo}
            handleNewMovimentation={handleNewMovimentation}
          />
        </div>
      )}

      {openModalNewPaymentsReceipts && (
        <div>
          <ModalNewPaymentsReceipts
            open={openModalNewPaymentsReceipts}
            setModalOpen={setOpenModalNewPaymentsReceipts}
            addPayments={addPayments}
            value={
              transactionAmount -
              (summedValue + summedFees + summedFines - summedAbatement)
            }
            transactionDate={transactionDate}
            transactionMemo={transactionMemo}
            handleNewPaymentsReceipts={handleNewPaymentsReceipts}
          />
        </div>
      )}
      <Dialog open={open} fullWidth maxWidth="md">
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          children={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              Adicionar Lançamentos
              <BtnMenu
                btnLabel="Novo"
                endIcon={<Add />}
                actions={erpActions}
                fontSize="13px"
              />
            </div>
          }
        />
        <DialogContent>
          <TabsErp
            headers={tabHeaders}
            tabIndex={tabIndex}
            onChange={(event, value) => {
              if (Number.isInteger(value)) setTabIndex(value);
            }}
            children={tabChildren}
          />
        </DialogContent>
        <DialogActions>
          <Btn autoFocus onClick={handleAdd} label="Adicionar" />
          <Btn
            autoFocus
            onClick={handleClose}
            bgcolor="tertiary"
            label="Fechar"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalSearch;
